import {AddToCartButton, useProductOptions} from '@shopify/hydrogen';
// import {defaultButtonStyles} from '../../elements/Button';

type Props = {
  label?: string;
  quantity?: number;
  showSoldOut?: boolean;
};

export default function SelectedVariantAddToCartButton({
  label = 'Add to cart',
  quantity = 1,
  showSoldOut = true,
}: Props) {
  const {selectedVariant} = useProductOptions();

  if (!selectedVariant || (!showSoldOut && !selectedVariant.availableForSale)) {
    return null;
  }

  return (
    <AddToCartButton
      // className={defaultButtonStyles()}
      className="w-fit text-main border border-main px-10 py-2 hover:bg-main hover:text-white truncate"
      disabled={!selectedVariant.availableForSale}
      quantity={quantity}
      variantId={selectedVariant?.id}
    >
      {label}
    </AddToCartButton>
  );
}
